import axiosClient from '../axiosClient';

export const getTickets = (params) =>
  axiosClient.get('/admin/support/tickets', { params });

export const getTicketDetail = (id) =>
  axiosClient.get(`/admin/support/tickets/${id}`);

export const updateTicketStatus = (id, data) =>
  axiosClient.patch(`/admin/support/tickets/${id}/status`, data);

export const addAdminReply = (id, data) =>
  axiosClient.post(`/admin/support/tickets/${id}/messages`, data);
